<template>
  <b-container style="margin-top:90px;" fluid >
        <audio-player :options="videoOptions" class="mx-auto" />
  </b-container>
</template>

<script>
import AudioPlayer from "@/components/Interactive/AudioPlayer/AudioPlayer.vue";

export default {
  name: "InteractiveAudio",
  components: {
    AudioPlayer
  },
  props: ["audioId"],
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        vvid: this.audioId,
        sources: [
          {
            src: "",//atob(this.videofile.replace("_", "/").replace("-", "+")),
            type: "audio/mpeg"
          }
        ]
      }
    };
  }
};
</script>
<style scoped>
</style>